import { render, staticRenderFns } from "./prmDetail.vue?vue&type=template&id=1a0b17b3&scoped=true&"
import script from "./prmDetail.vue?vue&type=script&lang=js&"
export * from "./prmDetail.vue?vue&type=script&lang=js&"
import style0 from "./prmDetail.vue?vue&type=style&index=0&id=1a0b17b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b17b3",
  null
  
)

export default component.exports